(function () {
  const MOBILE_BREAKPOINT = 768;
  const MEGA_MENU_CLOSE_DELAY = 280;

  function getAnnouncementHeight() {
    const announcement = document.querySelector('[data-verti-announcement-bar]');
    return announcement ? announcement.offsetHeight : 0;
  }

  function setHeaderOffsets(header) {
    const announcementHeight = getAnnouncementHeight();
    const headerHeight = header.offsetHeight;
    const totalHeight = announcementHeight + headerHeight;

    document.documentElement.style.setProperty('--verti-announcement-height', announcementHeight + 'px');
    header.style.setProperty('--verti-header-height', totalHeight + 'px');

    const drawer = header.querySelector('[data-verti-header-drawer]');
    if (drawer) {
      drawer.style.top = totalHeight + 'px';
      drawer.style.maxHeight = 'calc(100vh - ' + totalHeight + 'px)';
    }
  }

  function initVertiHeader(header) {
    const toggle = header.querySelector('[data-verti-header-toggle]');
    const drawer = header.querySelector('[data-verti-header-drawer]');
    const overlay = header.querySelector('[data-verti-header-overlay]');
    const navItems = header.querySelectorAll('[data-verti-header-nav-item]');

    if (!toggle || !drawer) return;

    let scrollPosition = 0;
    let scrollLockCount = 0;
    let megaMenuCloseTimer = null;
    let activeNavItem = null;

    function isMobile() {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    function lockBodyScroll() {
      if (scrollLockCount === 0) {
        scrollPosition = window.scrollY;
        document.body.classList.add('verti-header-menu-open');
        document.body.style.top = '-' + scrollPosition + 'px';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      }
      scrollLockCount += 1;
    }

    function unlockBodyScroll() {
      if (scrollLockCount <= 0) return;
      scrollLockCount -= 1;
      if (scrollLockCount > 0) return;
      document.body.classList.remove('verti-header-menu-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollPosition);
    }

    function closeMegaMenu() {
      clearTimeout(megaMenuCloseTimer);
      const hadOpenMegaMenu = activeNavItem !== null;
      navItems.forEach(function (navItem) {
        navItem.classList.remove('is-open');
        const trigger = navItem.querySelector('[data-verti-header-nav-trigger]');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
          if (document.activeElement === trigger) trigger.blur();
        }
      });
      activeNavItem = null;
      if (hadOpenMegaMenu) unlockBodyScroll();
    }

    function openMegaMenu(navItem) {
      if (isMobile()) return;
      clearTimeout(megaMenuCloseTimer);
      navItems.forEach(function (item) {
        if (item !== navItem) {
          item.classList.remove('is-open');
          const trigger = item.querySelector('[data-verti-header-nav-trigger]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
      });
      const isFirstOpen = activeNavItem === null;
      navItem.classList.add('is-open');
      const trigger = navItem.querySelector('[data-verti-header-nav-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      activeNavItem = navItem;
      if (isFirstOpen) lockBodyScroll();
    }

    function scheduleMegaMenuClose(navItem) {
      if (isMobile()) return;
      clearTimeout(megaMenuCloseTimer);
      megaMenuCloseTimer = setTimeout(function () {
        if (activeNavItem === navItem) {
          closeMegaMenu();
        }
      }, MEGA_MENU_CLOSE_DELAY);
    }

    function openMenu() {
      setHeaderOffsets(header);
      header.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
      drawer.setAttribute('aria-hidden', 'false');
      lockBodyScroll();
    }

    function closeMenu() {
      if (!header.classList.contains('is-open')) return;
      header.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      drawer.setAttribute('aria-hidden', 'true');
      unlockBodyScroll();
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      if (!isMobile()) return;
      if (header.classList.contains('is-open')) closeMenu();
      else openMenu();
    });

    if (overlay) {
      overlay.addEventListener('click', closeMenu);
    }

    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        if (isMobile()) closeMenu();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeMenu();
        closeMegaMenu();
      }
    });

    window.addEventListener('resize', function () {
      setHeaderOffsets(header);
      if (!isMobile()) {
        closeMenu();
      } else {
        closeMegaMenu();
      }
    });

    setHeaderOffsets(header);

    navItems.forEach(function (navItem) {
      const trigger = navItem.querySelector('[data-verti-header-nav-trigger]');
      if (!trigger) return;

      navItem.addEventListener('mouseenter', function () {
        openMegaMenu(navItem);
      });

      navItem.addEventListener('mouseleave', function () {
        scheduleMegaMenuClose(navItem);
      });

      trigger.addEventListener('click', function (event) {
        if (isMobile()) return;
        event.preventDefault();
        if (navItem.classList.contains('is-open')) closeMegaMenu();
        else openMegaMenu(navItem);
      });
    });

    document.addEventListener('click', function (event) {
      if (isMobile()) return;
      const clickedInsideNav = Array.from(navItems).some(function (navItem) {
        return navItem.contains(event.target);
      });
      if (!clickedInsideNav) closeMegaMenu();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-verti-header]').forEach(initVertiHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const header = event.target.querySelector('[data-verti-header]');
    if (header) initVertiHeader(header);
    document.documentElement.style.setProperty(
      '--verti-announcement-height',
      getAnnouncementHeight() + 'px'
    );
  });

  window.addEventListener('load', function () {
    document.querySelectorAll('[data-verti-header]').forEach(function (header) {
      setHeaderOffsets(header);
    });
  });
})();
